/**
 * Meta Pixel conversion tracking for Forminator submissions.
 *
 * Reports a successful submission of the watched form(s) to the Meta Pixel.
 * Which forms are watched, and which event is sent, come from PHP via the
 * `tmMetaPixel` config (see functions/meta-pixel.php).
 *
 * Inert unless the base pixel loaded and at least one form is configured, so an
 * ad blocker or a disabled pixel never throws.
 */

/**
 * Pulls the numeric Forminator form ID out of a submitted form element.
 *
 * Forminator renders each form with the DOM id `forminator-module-<id>`.
 *
 * @param {HTMLElement} form The submitted form element.
 * @returns {string} The form ID, or an empty string when it can't be read.
 */
const getFormId = (form) => {
  const match = /^forminator-module-(\d+)$/.exec(form?.id || "");

  return match ? match[1] : "";
};

/**
 * Binds Forminator's success event to a Meta Pixel conversion.
 *
 * @returns {void}
 */
export default () => {
  const config = window.tmMetaPixel;

  if (!config || typeof window.fbq !== "function") {
    return;
  }

  const trackedIds = (config.formIds || []).map(String);
  const eventName = config.event || "CompleteRegistration";

  if (!trackedIds.length) {
    return;
  }

  // Forminator can emit its success event more than once for a single
  // submission, and the sign-up template re-triggers form setup by hand.
  // Duplicate conversions are silent and corrupt reporting, so fire once.
  const reported = new Set();

  jQuery(document).on(
    "forminator:form:submit:success",
    "form.forminator-custom-form",
    (e) => {
      const formId = getFormId(e.target);

      if (!formId || !trackedIds.includes(formId) || reported.has(formId)) {
        return;
      }

      reported.add(formId);
      window.fbq("track", eventName);
    }
  );
};
